<template>
  <div class="tw:flex tw:items-center tw:min-h-[201px] tw:flex-col tw:justify-center tw:text-center tw:grow tw:w-full">
    <div
      class="tw:flex tw:flex-col tw:bg-blue-100 tw:border tw:border-blue-300 tw:border-dashed tw:rounded-lg tw:min-h-[201px] tw:flex tw:w-full tw:items-start tw:justify-start"
      @dragover="e => emit('dragover', e)"
      @dragleave="e => emit('dragleave', e)"
      @drop="e => emit('drop', e)">
      <input
        id="fileInput"
        ref="file"
        type="file"
        multiple
        name="file"
        class="tw:opatity-0 tw:overflow-hidden tw:absolute tw:h-[1px] tw:w-[1px]"
        accept=".jpg,.jpeg,.png,.webp"
        @change="e => onChange(e)" />

      <div v-show="files.length" class="tw:flex tw:w-full tw:flex-wrap">
        <div v-for="file in files" :key="file.name" class="tw:flex tw:p-2">
          <div class="tw:relative">
            <button
              type="button"
              class="close-btn tw:absolute tw:top-[3px] tw:right-[3px] tw:mb-0 focus:tw:outline-none no-lineheight tw:justify-end"
              @click="removeImage(files.indexOf(file))">
              <Close class="tw:size-3.5" />
            </button>
            <UiTooltip
              v-show="file.size > 20000000"
              tooltip-position="top"
              :label="$t('app_images_upload_failed_max_size')"
              class="tw:w-6 tw:absolute tw:bottom-[3px] tw:left-[3px]">
              <ExclamationMark class="tw:fill-red-700 tw:size-6" />
            </UiTooltip>
            <img
              alt="img"
              :class="{ 'wrong-image': file.size > 20000000 }"
              class="preview-img tw:rounded-md"
              :src="generateURL(file)" />
          </div>
        </div>
      </div>
      <label for="fileInput" class="file-label" :class="files.length > 0 ? 'tw:my-4 tw:mx-auto' : ' tw:m-auto'">
        <div v-if="isDragging">{{ $t('app_images_upload_button_text') }}</div>
        <div v-else>
          <div
            class="tw:w-[fit-content] tw:font-bold tw:border tw:m-auto tw:bg-blue-700 tw:border-blue-700 tw:text-white tw:text-center tw:cursor-pointer tw:py-[0.44rem] tw:px-8 tw:text-sm tw:rounded-lg">
            {{ $t('app_images_header_button_text') }}
          </div>
          <p class="tw:mt-3 tw:text-black">{{ $t('app_images_upload_button_text') }}</p>
        </div>
      </label>
    </div>
  </div>
</template>

<script setup lang="ts">
import Close from '@/components/icons/Close.svg?component'
import ExclamationMark from '@/components/icons/ExclamationMark.svg?component'
import UiTooltip from '@/components/dashboard/ui/UiTooltip.vue'

interface Props {
  isDragging: boolean
  files: File[]
}
defineProps<Props>()

const emit = defineEmits<{
  onChange: [event: Event]
  remove: [index: number]
  dragover: [event: DragEvent]
  dragleave: [event: DragEvent]
  drop: [event: DragEvent]
}>()

const onChange = (e: Event) => emit('onChange', e)
const removeImage = (index: number) => emit('remove', index)

const generateURL = (file: File): string => {
  let fileSrc = URL.createObjectURL(file)
  setTimeout(() => {
    URL.revokeObjectURL(fileSrc)
  }, 1000)
  return fileSrc
}
</script>

<style scoped>
.preview-img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  background-color: var(--tw-color-gray-300);
}
.close-btn {
  background-color: white;
  padding-left: 4px;
  padding-top: 4px;
  border-radius: 10px;
  padding-bottom: 1px;
  padding-right: 1px;
}
.wrong-image {
  border: 2px solid var(--tw-color-red-800);
}
</style>
